import API_ENDPOINTS from '../api/endpoints';
import apiClient from '../api/apiClient';

// Fetch favorite status (GET) or Toggle favorite (POST)
export const toggleFavorite = async (providerId, providerType, method = "POST") => {
  try {
    let response;

    if (method === "GET") {
      // ✅ Check favorite status
      response = await apiClient.get(API_ENDPOINTS.FAVORITES.FAVORITE, {
        params: { id: providerId, type: providerType },
      });
    } else {
      // ✅ Toggle favorite
      response = await apiClient.post(API_ENDPOINTS.FAVORITES.FAVORITE, {
        id: providerId,
        type: providerType, // "freelancer" or "business"
      });
    }

    return response.data;
  } catch (error) {
    console.error(`Favorite ${method === "GET" ? "fetch" : "toggle"} failed:`, error);
    throw error;
  }
};

// Fetch all favorited freelancers for the authenticated user
export const getAllFavorites = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.FAVORITES.ALL_FAVORITES);
    return response.data; // List of favorite freelancers
  } catch (error) {
    console.error("Failed to fetch favorites:", error);
    throw error;
  }
};